import { Button } from 'react-aria-components';
import styled from 'styled-components';

export const IconButton = styled(Button)<{
  $isRound: boolean;
  $width?: number;
}>`
  background: inherit;
  border: 0;
  border-radius: ${({ $isRound }) => ($isRound ? 'var(--radius-fullyrounded)' : 'var(--radius-base)')};
  width: ${({ $width }) => ($width ? `${$width}px` : 'fit-content')};

  &:not(:is(.close-modal)) {
    display: flex;
    position: relative;
  }

  &[data-focus-visible],
  &:focus-visible {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);
    outline: 0;
  }

  & svg {
    width: ${({ $width }) => ($width ? `${$width}px` : '24px')};
  }
`;

export const InnerWrapper = styled.span<{ $isPending: boolean }>`
  width: fit-content;

  &:not(:is(.close-modal &)) {
    display: flex;
    justify-content: center;
    align-items: center;
    visibility: ${props => (props.$isPending ? 'hidden' : 'visible')};
  }
`;
